<div class="container-fluid cards-container">
    <chart-card
        id="continuityQualitySupplyQualityDecreeChart"
        [title]="texts.qualityDecree.title"
        [error]="qualityDecreeChartError"
        [isLoading]="!qualityDecreeChartDataSignal()[0].organizationId"
        [series]="qualityDecreeChartSeries"
        [dataLabels]="qualityDecreeChartDataLabels"
        [yaxis]="qualityDecreeYaxis"
        [precision]="texts.qualityDecree.precision"
        [dashArray]="qualityDecreeDashArray"
        [grid]="qualityDecreeChartGrid"
        [xaxisTitle]="texts.qualityDecree.xaxisTitle"
        [unitTooltip]="texts.qualityDecree.unitTooltip"
        class="h-100">
    </chart-card>

    <div class="row g-3">
        <div class="col-sm-12 col-lg-6">
            <chart-card
                id="continuityQualitySupplyOutagesFrequencyChart"
                [title]="texts.outagesFrequency.title"
                [error]="outagesFrequencyChartError"
                [isLoading]="!outagesFrequencyChartDataSignal()[0].organizationId"
                [series]="outagesFrequencyChartSeries"
                [dataLabels]="outagesFrequencyChartDataLabels"
                [yaxis]="outagesFrequencyYaxis"
                [precision]="texts.outagesFrequency.precision"
                [grid]="outagesFrequencyChartGrid"
                [xaxisTitle]="texts.outagesFrequency.xaxisTitle"
                [unitTooltip]="texts.outagesFrequency.unitTooltip"
                class="h-100">
            </chart-card>
        </div>

        <div class="col-sm-12 col-lg-6">
            <chart-card
                id="continuityQualitySupplyOutagesComparisonChart"
                [title]="texts.outagesComparison.title"
                [descriptionTitle]="texts.outagesComparison.descriptionTitle"
                [descriptionContent]="texts.outagesComparison.descriptionContent"
                [error]="outagesComparisonChartError"
                [isLoading]="!outagesComparisonChartDataSignal()[0].organizationId"
                [type]="'rangeBar'"
                [dataLabels]="outagesComparisonDataLabels"
                [series]="outagesComparisonChartSeries"
                [plotOptions]="outagesComparisonPlotOptions"
                [customTooltip]="outagesComparisonCustomTooltip"
                [yaxis]="outagesComparisonYaxis"
                cardClass="h-100"></chart-card>
        </div>
    </div>
</div>
